import {CardContent, CircularProgress, Collapse, Link, TextField, Typography} from "@material-ui/core";
import React, {useState} from "react";
import {makeStyles} from "@material-ui/styles";
import { formatDate } from '../../../../helpers/utils';
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import EducationHistoryFields from "../acordionFields/EducationHistoryFields";
const useStyles = makeStyles((theme) => ({
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSection: {
    padding: '16px 22px',
    background: '#fff',
    marginBottom: '15px',
    borderRadius: '3px',
  },
  contentSectionHeaderTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#000',
  },
  contentSectionContent: {

  },
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  addNewRelationshipLink: {
    textTransform: 'capitalize',
    textDecoration: 'none',
    fontWeight: '600',
    cursor: 'pointer',
    marginBottom: '16px',
    display: 'inline-block',
    '&:hover': {
      textDecoration: 'none',
    }
  },
}));
const PrivateBio = (props) => {
  const classes = useStyles();
  const {contact, handleTabChange, tab,handleFieldChange} = props;
  const [privateBio,setPrivateBio] = useState(contact.privateBio);

  return (
    <div className={classes.contentSection}>
      <div className={classes.contentSectionHeader} onClick={(event) => handleTabChange(event, 2)}>
        <Typography variant='h5' className={`${classes.contentSectionHeaderTitle} ${tab === 2 ? classes.tabActive : ''}`}>Private Bio</Typography>
        {tab === 2 ? <ExpandLess /> : <ExpandMore />}
      </div>
      <Collapse in={tab === 2}>
        <div className={classes.contentSectionContent}>
          <div className={classes.formGroup}>
            <TextField
              fullWidth
              multiline
              rows={10}
              label="Private Bio"
              name="privateBio"
              onChange={(e) => setPrivateBio(e.target.value)}
              onBlur={(e) => handleFieldChange(e, privateBio)}
              value={privateBio}
              variant="outlined"
            />
          </div>
        </div>
      </Collapse>
    </div>
  )
}

export default PrivateBio;